import React, { useState, useMemo } from "react";
import { GoogleMap, Marker, InfoWindow, useJsApiLoader } from "@react-google-maps/api";
import { useNavigate } from "react-router-dom";

const containerStyle = {
  width: "100%",
  height: "500px",
};

const defaultCenter = {
  lat: 32.7157, // Default to San Diego
  lng: -117.1611,
};

const ListingsMap = ({ listings, apiKey, hoveredPropertyId, setHoveredPropertyId }) => {
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: apiKey,
  });
  const navigate = useNavigate();
  const [infoWindowId, setInfoWindowId] = useState(null);

  // Compute center based on listings
  const center = useMemo(() => {
    const valid = listings.filter(l => l.lat && l.lng);
    if (valid.length === 0) return defaultCenter;
    const avgLat = valid.reduce((sum, l) => sum + Number(l.lat), 0) / valid.length;
    const avgLng = valid.reduce((sum, l) => sum + Number(l.lng), 0) / valid.length;
    return { lat: avgLat, lng: avgLng };
  }, [listings]);

  if (!isLoaded) return <div>Loading Map...</div>;

  return (
    <GoogleMap mapContainerStyle={containerStyle} center={center} zoom={10}>
      {listings.map((listing) =>
        listing.lat && listing.lng ? (
          <Marker
            key={listing.id || listing.MLSNumber}
            position={{ lat: Number(listing.lat), lng: Number(listing.lng) }}
            title={listing.address || listing.L_Address}
            icon={hoveredPropertyId === listing.id || infoWindowId === listing.id
              ? 'http://maps.google.com/mapfiles/ms/icons/blue-dot.png'
              : 'http://maps.google.com/mapfiles/ms/icons/red-dot.png'}
            onClick={() => navigate(`/property/${listing.id}`)}
            onMouseOver={() => {
              setHoveredPropertyId(listing.id);
              setInfoWindowId(listing.id);
            }}
            onMouseOut={() => {
              setHoveredPropertyId(null);
              setInfoWindowId(null);
            }}
          >
            {(infoWindowId === listing.id) && (
              <InfoWindow
                position={{ lat: Number(listing.lat), lng: Number(listing.lng) }}
                onCloseClick={() => setInfoWindowId(null)}
              >
                <div
                  style={{ cursor: "pointer", minWidth: 180 }}
                  onClick={() => navigate(`/property/${listing.id}`)}
                >
                  <img src={listing.PhotoURL} alt="" style={{ width: 160, height: 90, objectFit: 'cover', borderRadius: 4, marginBottom: 6 }} />
                  <div style={{ fontWeight: 600, fontSize: 16, marginBottom: 2 }}>
                    ${Number(listing.ListPrice).toLocaleString()}
                  </div>
                  <div style={{ fontSize: 13 }}>{listing.FullAddress}</div>
                </div>
              </InfoWindow>
            )}
          </Marker>
        ) : null
      )}
    </GoogleMap>
  );
};

export default ListingsMap; 